import DatePicker from "components/app/function/DatePicker";
import NumberInput from "components/app/function/NumberInput";
import TimePicker from "components/app/function/TimePicker";
import { Textarea } from "components/ui/textarea";
import UsedEndMonthDay from "pages/business-suite/UsedEndMonthDay";
import React from "react";

const RequestleaveApplicationForm = ({ monthDate, entitlements, employeeInitRequest, handleChangeLeaveRequest, leaveApplicationFrom, setValuesRemarkLeave }: any) => {
  return (
    <>
      {/* Entitlements */}
      <div>
        <h4 className="text-xl font-semibold text-blue-600">Entitlements</h4>

        <table className="min-w-full border-collapse  rounded-md overflow-hidden mt-2">
          <thead className="sticky top-0 left-0 text-xs text-gray-700  bg-gray-300 dark:bg-[#2c3a52] dark:text-gray-400">
            <tr className="border-none text-[15px] text-start  ">
              <th className="px-4 py-3 text-start">{monthDate}</th>
              <th className="px-4 py-3 text-end">Jan</th>
              <th className="px-4 py-3 text-end">Feb</th>
              <th className="px-4 py-3 text-end">Mar</th>
              <th className="px-4 py-3 text-end">Apr</th>
              <th className="px-4 py-3 text-end">May</th>
              <th className="px-4 py-3 text-end">Jun</th>
              <th className="px-4 py-3 text-end">Jul</th>
              <th className="px-4 py-3 text-end">Aug</th>
              <th className="px-4 py-3 text-end">Sep</th>
              <th className="px-4 py-3 text-end">Oct</th>
              <th className="px-4 py-3 text-end">Nov</th>
              <th className="px-4 py-3 text-end">Dec</th>
            </tr>
          </thead>
          <tbody>
            {entitlements?.map((item: any, index: number) => {
              return (
                <tr key={index} className={`text-center group  ${index % 2 === 0 ? "bg-gray-100 dark:bg-[#1e293b] " : "bg-gray-200 dark:bg-[#2c3a52] "} hover:bg-gray-300`}>
                  <UsedEndMonthDay item={item} />
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {/* Leave Type */}
      <div>
        <h4 className="text-xl font-semibold text-blue-600">Leave Type</h4>
        <div className="grid lg:grid-cols-6 md:grid-cols-4 grid-cols-3 gap-2 mt-2">
          {[
            "Annual Leave",
            "Prolong illness Leave",
            "Compassinonate Leave",
            "Block Leave",
            "Unpaid Leave",
            "Sick Leave",
            "Special Leave",
            "Marriage leave",
            "Paternlty Leave",
            "Change Day-Off Leave",
          ].map((leave_type, index) => (
            <button
              disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
              key={index}
              onClick={() => handleChangeLeaveRequest("leave_type", leave_type)}
              className={`border outline-none px-4  py-1.5 rounded-lg text-sm font-semibold ${leaveApplicationFrom.leave_type === leave_type ? "bg-blue-500 text-white" : ""}`}
            >
              <p className="text-md font-semibold line-clamp-2 overflow-hidden">{leave_type}</p>
            </button>
          ))}
        </div>
      </div>

      {/* Leave Detail */}
      <div className="">
        <h4 className="text-xl font-semibold text-blue-600">Leave Detail</h4>
        {/* Day Type Selection */}
        <div className="grid grid-cols-6 gap-2 mb-4 mt-2">
          {["Full Day", "During Working Hour"].map((type) => (
            <button
              disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
              key={type}
              onClick={() => handleChangeLeaveRequest("leave_period", type)}
              className={`border px-4 py-1.5 rounded-lg text-sm font-semibold ${leaveApplicationFrom.leave_period === type ? "bg-blue-500 text-white" : ""}`}
            >
              <p className="text-md font-semibold line-clamp-2 overflow-hidden">{type}</p>
            </button>
          ))}
        </div>
        {/* Conditional Inputs */}
        <div className="grid grid-cols-6 gap-4 mb-4 mt-2">
          {leaveApplicationFrom.leave_period === "Full Day" ? (
            <>
              <div>
                <label>From</label>
                <DatePicker
                  disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                  className="py-3 h-[45px] text-[15px] border border-gray-300 mt-2"
                  value={leaveApplicationFrom.starting_date}
                  onChange={(e) => handleChangeLeaveRequest("starting_date", e)}
                />
              </div>
              <div>
                <label>No. Of Day</label>
                <NumberInput
                  disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                  className="py-[22px] text-[17px]  mt-2"
                  value={leaveApplicationFrom.no_of_day}
                  onChange={(e) => handleChangeLeaveRequest("no_of_day", Number(e.target.value))}
                />
              </div>
              <div>
                <label>To</label>
                <DatePicker
                  disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                  className="py-3 h-[45px] text-[17px] border border-gray-300  mt-2"
                  value={leaveApplicationFrom.ending_date}
                  onChange={(e) => handleChangeLeaveRequest("toDate", e)}
                />
              </div>
            </>
          ) : (
            <>
              <div>
                <label>Working Date</label>
                <DatePicker
                  disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                  className="py-3 h-[45px] text-[17px] border border-gray-300  mt-2"
                  value={leaveApplicationFrom.starting_date}
                  onChange={(e) => handleChangeLeaveRequest("starting_date", e)}
                />
              </div>
              <div>
                <label>From Time</label>
                <TimePicker
                  disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                  className="mt-2"
                  value={leaveApplicationFrom.starting_time}
                  onChange={(value) => handleChangeLeaveRequest("starting_time", value)}
                />
              </div>
              <div>
                <label>To Time</label>
                <TimePicker
                  disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                  className=" mt-2"
                  value={leaveApplicationFrom.ending_time}
                  onChange={(value) => handleChangeLeaveRequest("ending_time", value)}
                />
              </div>
            </>
          )}
        </div>
        <div>
          <label> Reason</label>
          <Textarea
            disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
            className="text-[15px] focus:border-none focus:border-1 mt-2"
            value={leaveApplicationFrom.reason}
            onChange={(e) => {
              handleChangeLeaveRequest("reason", e.target.value);
              setValuesRemarkLeave(e.target.value);
            }}
            rows={4}
          />
        </div>
      </div>
    </>
  );
};

export default RequestleaveApplicationForm;
